import { StrictMode, useEffect } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './index.css';
import App from './App.jsx';
import { createAppStore } from './store.js';
import { initSiteMotion } from './reveal.js';

const Root = () => {
  // Runs after React has committed, so the observer sees every .reveal element.
  useEffect(() => initSiteMotion(), []);

  return (
    <Provider store={createAppStore()}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  );
};

const container = document.getElementById('root');
const tree = (
  <StrictMode>
    <Root />
  </StrictMode>
);

// Production builds ship prerendered markup (see scripts/prerender.js), so
// hydrate it. `npm run dev` serves an empty #root, so mount fresh.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
